// extracted by mini-css-extract-plugin
export default {"chatActive":"chatActive--ebf39f9f1935d66bc1fd","resultMessage":"resultMessage--c1c653461e9b6663d518"};